import { render } from "./SkeletonTile.vue?vue&type=template&id=8be6da7e"
import script from "./SkeletonTile.vue?vue&type=script&lang=js"
export * from "./SkeletonTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__